module.exports = __webpack_public_path__ + "static/media/json_file.3a753c2d.png";